module.exports = __webpack_public_path__ + "h5/img/certification2.408d12bf.png";